import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'

const PenaltyModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  defaultInterest, onDefaultInterestChange, defaultInterestError, setDefaultInterestError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Penalty'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='defaultInterest' maxLength={12}
      label='Default interest'
      value={defaultInterest} onChange={onDefaultInterestChange}
      error={defaultInterestError} setError={setDefaultInterestError}
    />

  </ModalFormUI>

export default PenaltyModalUI
